const determineAttendancePermissions = ({ roles, sefRoles, workspaceDetails }) => {
  if (sefRoles.isGodAdmin) return true

  // must be participant so they should be able to view their own calendar
  if (!roles.length) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.attendances_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true
  if (sefRoles.isSuperAdmin) return true

  return false
}

const determineBudgetPermissions = ({ sefRoles, workspaceDetails }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.purchase_requests_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determinePartnersPermissions = ({ sefRoles }) => {
  if (sefRoles.isGodAdmin) return true

  if (sefRoles.isPlatformAdmin) return true
  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determinePurchasesPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.purchase_requests_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true

  return false
}

const determineSuppliersPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.purchase_requests_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true

  return false
}

const determineOutputAreaPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.outputs_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determineOutputsPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.outputs_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin ||
    sefRoles.isPartnerAdmin ||
    sefRoles.isWorksiteOutputsAdmin ||
    sefRoles.isPartnerDistrictOutputsAdmin ||
    sefRoles.isSuperAdmin
  )
}

const determineParticipantPermissions = ({ sefRoles, workspaceDetails }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.participant_management_enabled
  if (!featureEnabled) return false

  return (
    sefRoles.isPartnerDistrictPeopleAdmin ||
    sefRoles.isSuperAdmin ||
    sefRoles.isPartnerAdmin ||
    sefRoles.isWorkspaceSigningAdmin ||
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin ||
    sefRoles.isWorksitePeopleAdmin
  )
}

const determinePayrollPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.payroll_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determineAgreementPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.participant_management_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isWorkspaceSigningAdmin) return true

  return false
}

const determineWorksitesPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled =
    firstWorkspace.outputs_enabled ||
    firstWorkspace.participant_management_enabled ||
    firstWorkspace.attendances_enabled ||
    true // temporary so SEF SIPs can see worksites
  if (!featureEnabled) return false

  return (
    sefRoles.isWorkspaceAdmin ||
    sefRoles.isWorkspaceProjectAdmin ||
    sefRoles.isPartnerAdmin ||
    sefRoles.isWorksiteOutputsAdmin ||
    sefRoles.isWorksitePeopleAdmin ||
    sefRoles.isSuperAdmin
  )
}

const determineIndicatorPermissions = ({ sefRoles, workspaceDetails = [] }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled = firstWorkspace.outputs_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true

  return false
}

const determineDistrictsPermissions = ({ sefRoles, workspaceDetails }) => {
  if (sefRoles.isGodAdmin) return true

  const firstWorkspace = workspaceDetails[0]
  if (!firstWorkspace) return false

  const featureEnabled =
    firstWorkspace.outputs_enabled || firstWorkspace.participant_management_enabled
  if (!featureEnabled) return false

  if (sefRoles.isWorkspaceAdmin) return true
  if (sefRoles.isWorkspaceProjectAdmin) return true
  if (sefRoles.isPartnerAdmin) return true
  if (sefRoles.isPartnerDistrictOutputsAdmin) return true

  return false
}

const permissions = {
  agreements: determineAgreementPermissions,
  areas: determineOutputAreaPermissions,
  attendances: determineAttendancePermissions,
  budgets: determineBudgetPermissions,
  districts: determineDistrictsPermissions,
  indicators: determineIndicatorPermissions,
  outputs: determineOutputsPermissions,
  participants: determineParticipantPermissions,
  partners: determinePartnersPermissions,
  payroll: determinePayrollPermissions,
  purchases: determinePurchasesPermissions,
  suppliers: determineSuppliersPermissions,
  worksites: determineWorksitesPermissions
}

const checkRoutingPermissions = ({ roles, sefRoles, workspaceDetails, featureName }) => {
  const permissionCheck = permissions[featureName]
  if (!permissionCheck) return true

  return permissionCheck({ roles, sefRoles, workspaceDetails })
}

export default checkRoutingPermissions
